
<template>
  <svg
    id="stacked-pills"
    data-name="stacked-pills"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1859.37 1039.72"
    version="1.1"
    x="0px"
    y="0px"
    style="enable-background: new 0 0 50 50"
    xml:space="preserve"
    class="stacked-svg"
  >
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M31.39,1042.33c0,12.75,11.54,23.09,25.78,23.09S83,1055.08,83,1042.33c0-1.23.16-10.7,0-11.87-1.93-11-12.87-11.22-25.74-11.22-13.05,0-24.07-.19-25.78,11.08C31.23,1031.34,31.39,1041.27,31.39,1042.33Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="25.86"
        cy="1003.28"
        rx="25.79"
        ry="20.14"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M58.13,1011.89v36.34s-2.23.68-2.4,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M60.3,1045.08s8.69-2.09,14.3-7.39c5.84-5.51,8.39-13.76-4.13-21.78a29,29,0,0,0-10.17-3.65v-.85a25.89,25.89,0,0,1,10.87,3.74c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M83.91,1007.4c0,12-11.55,21.72-25.79,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06.05-11.17,1.94-10.38,12.87-10.55,25.74-10.55,13.05,0,24.08-.18,25.79,10.42C84.06,997.07,83.91,1006.4,83.91,1007.4Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="26.8"
        cy="969.72"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="26.8"
        cy="968.23"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M32.66,977.65c0,12.75,11.55,23.09,25.79,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.69,0-11.87-1.94-11-12.87-11.22-25.74-11.22-13.05,0-24.08-.19-25.79,11.08C32.51,966.66,32.66,976.59,32.66,977.65Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="27.13"
        cy="938.6"
        rx="25.79"
        ry="20.14"
      />

      <path
        class="cls-1-stack white"
        d="M59.4,947.21v36.35s-2.23.67-2.39,0,1.19-36.35,1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M61.58,980.4s8.68-2.09,14.29-7.39c5.85-5.51,8.39-13.76-4.12-21.78a29.08,29.08,0,0,0-10.17-3.65v-.85a25.89,25.89,0,0,1,10.87,3.74c7.69,5,15.11,14.52,4.07,24.71a28,28,0,0,1-14.94,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M32.66,941.37c0,12.75,11.55,23.09,25.79,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.88-1.94-11-12.87-11.21-25.74-11.21-13.05,0-24.08-.19-25.79,11.07C32.51,930.38,32.66,940.3,32.66,941.37Z"
        transform="translate(-31.32 -26.93)"
      />

      <ellipse
        class="cls-2-stack white"
        cx="27.13"
        cy="902.32"
        rx="25.79"
        ry="20.14"
      />

      <path
        class="cls-1-stack white"
        d="M59.4,910.93v36.34s-2.23.68-2.39,0,1.19-36.34,1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M61.58,944.12s8.68-2.1,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a29.08,29.08,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.07,24.72a28,28,0,0,1-14.94,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M84.23,897.73c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.7.05-11.87,1.93-11,12.87-11.22,25.74-11.22,13,0,24.08-.19,25.79,11.08C84.38,886.74,84.23,896.66,84.23,897.73Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="27.12"
        cy="858.68"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M57.49,867.29v36.34s2.22.68,2.39,0-1.2-36.34-1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M55.31,900.48s-8.68-2.09-14.3-7.39c-5.84-5.52-8.38-13.76,4.13-21.78a29,29,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.87,3.73c-7.69,5-15.11,14.53-4.08,24.72a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M83.91,866.09c0,12-11.55,21.72-25.79,21.72s-25.79-9.72-25.79-21.72c0-1.16-.16-10.06.05-11.17,1.94-10.38,12.87-10.55,25.74-10.55,13.05,0,24.08-.18,25.79,10.42C84.06,855.75,83.91,865.09,83.91,866.09Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="26.8"
        cy="828.41"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="26.8"
        cy="826.92"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M83.91,829.16c0,12-11.55,21.72-25.79,21.72s-25.79-9.73-25.79-21.72c0-1.16-.16-10.06.05-11.17,1.94-10.38,12.87-10.55,25.74-10.55,13.05,0,24.08-.18,25.79,10.42C84.06,818.82,83.91,828.16,83.91,829.16Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="26.8"
        cy="791.48"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="26.8"
        cy="789.99"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M84.23,795.32c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.7.05-11.87,1.93-11,12.87-11.22,25.74-11.22,13,0,24.08-.19,25.79,11.08C84.38,784.33,84.23,794.26,84.23,795.32Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="27.12"
        cy="756.27"
        rx="25.79"
        ry="20.14"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M57.49,764.88v36.34s2.22.68,2.39,0-1.2-36.34-1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M55.31,798.07S46.63,796,41,790.68c-5.84-5.51-8.38-13.76,4.13-21.78a29,29,0,0,1,10.17-3.65v-.85a25.89,25.89,0,0,0-10.87,3.74c-7.69,5-15.11,14.52-4.08,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M32.66,760.59c0,12.75,11.55,23.09,25.79,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.88-1.94-11-12.87-11.21-25.74-11.21-13.05,0-24.08-.19-25.79,11.07C32.51,749.6,32.66,759.52,32.66,760.59Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="27.13"
        cy="721.54"
        rx="25.79"
        ry="20.14"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M59.4,730.15v36.34s-2.23.68-2.39,0,1.19-36.34,1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M61.58,763.34s8.68-2.1,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a29.08,29.08,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.07,24.72a28,28,0,0,1-14.94,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M83.91,729.28c0,12-11.55,21.72-25.79,21.72s-25.79-9.73-25.79-21.72c0-1.16-.16-10.07.05-11.17,1.94-10.38,12.87-10.55,25.74-10.55,13.05,0,24.08-.18,25.79,10.42C84.06,718.94,83.91,728.28,83.91,729.28Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="26.8"
        cy="691.59"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="26.8"
        cy="690.11"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M31.39,696.07c0,12.75,11.54,23.08,25.78,23.08S83,708.82,83,696.07c0-1.23.16-10.7,0-11.88C81,673.16,70,673,57.17,673c-13.05,0-24.07-.19-25.78,11.07C31.23,685.08,31.39,695,31.39,696.07Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="25.86"
        cy="657.02"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M58.13,665.62V702s-2.23.68-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M60.3,698.82s8.69-2.1,14.3-7.39c5.84-5.52,8.39-13.76-4.13-21.78A28.8,28.8,0,0,0,60.3,666v-.84a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.71a27.93,27.93,0,0,1-15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M83.91,661.14c0,12-11.55,21.72-25.79,21.72s-25.79-9.73-25.79-21.72c0-1.16-.16-10.07.05-11.17,1.94-10.38,12.87-10.55,25.74-10.55,13.05,0,24.08-.18,25.79,10.42C84.06,650.8,83.91,660.14,83.91,661.14Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="26.8"
        cy="623.45"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="26.8"
        cy="621.97"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M32.66,631.39c0,12.75,11.55,23.09,25.79,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.88-1.94-11-12.87-11.21-25.74-11.21-13.05,0-24.08-.19-25.79,11.07C32.51,620.4,32.66,630.32,32.66,631.39Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="27.13"
        cy="592.34"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M59.4,600.94v36.35s-2.23.68-2.39,0,1.19-36.35,1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M61.58,634.14s8.68-2.1,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a28.69,28.69,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.07,24.71a27.89,27.89,0,0,1-14.94,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M31.39,591.63c0,12.75,11.54,23.09,25.78,23.09S83,604.38,83,591.63c0-1.23.16-10.7,0-11.88C81,568.72,70,568.54,57.17,568.54c-13.05,0-24.07-.19-25.78,11.07C31.23,580.64,31.39,590.56,31.39,591.63Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="25.86"
        cy="552.58"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M58.13,561.19v36.34s-2.23.68-2.4,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M60.3,594.38S69,592.28,74.6,587c5.84-5.52,8.39-13.76-4.13-21.78a29,29,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.72a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M83.91,556.7c0,12-11.55,21.72-25.79,21.72s-25.79-9.73-25.79-21.72c0-1.16-.16-10.06.05-11.17C34.32,535.15,45.25,535,58.12,535c13.05,0,24.08-.18,25.79,10.42C84.06,546.36,83.91,555.7,83.91,556.7Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="26.8"
        cy="519.02"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="26.8"
        cy="517.53"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M32.66,517C32.66,529.7,44.21,540,58.45,540S84.24,529.7,84.24,517c0-1.23.16-10.7,0-11.87-1.94-11-12.87-11.22-25.74-11.22-13.05,0-24.08-.19-25.79,11.08C32.51,506,32.66,515.88,32.66,517Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="27.13"
        cy="477.9"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M59.4,486.51v36.34s-2.23.68-2.39,0,1.19-36.34,1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M61.58,519.7s8.68-2.09,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a29.08,29.08,0,0,0-10.17-3.65V486a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.53,4.07,24.72a28,28,0,0,1-14.94,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M32.66,470.67c0,12.75,11.55,23.08,25.79,23.08s25.79-10.33,25.79-23.08c0-1.23.16-10.7,0-11.88-1.94-11-12.87-11.21-25.74-11.21-13.05,0-24.08-.2-25.79,11.07C32.51,459.68,32.66,469.6,32.66,470.67Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="27.13"
        cy="431.61"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M59.4,440.22v36.35s-2.23.68-2.39,0,1.19-36.35,1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M61.58,473.42s8.68-2.1,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a28.88,28.88,0,0,0-10.17-3.66v-.85a26.05,26.05,0,0,1,10.87,3.74c7.69,5,15.11,14.52,4.07,24.71a27.89,27.89,0,0,1-14.94,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M83.91,419.39c0,12-11.55,21.72-25.79,21.72s-25.79-9.73-25.79-21.72c0-1.16-.16-10.07.05-11.17,1.94-10.38,12.87-10.55,25.74-10.55,13.05,0,24.08-.18,25.79,10.42C84.06,409.05,83.91,418.39,83.91,419.39Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="26.8"
        cy="381.71"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="26.8"
        cy="380.22"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M170.83,1040.92c0,12.75-11.54,23.08-25.79,23.08s-25.78-10.33-25.78-23.08c0-1.23-.16-10.7,0-11.88,1.94-11,12.87-11.21,25.74-11.21,13.06,0,24.08-.19,25.79,11.07C171,1029.93,170.83,1039.85,170.83,1040.92Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="113.73"
        cy="1001.87"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M144.09,1010.47v36.35s2.23.68,2.39,0-1.19-36.35-1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M141.92,1043.67s-8.69-2.1-14.3-7.39c-5.85-5.52-8.39-13.76,4.13-21.78a28.73,28.73,0,0,1,10.17-3.66V1010a26,26,0,0,0-10.88,3.73c-7.69,5-15.11,14.52-4.07,24.71a27.93,27.93,0,0,0,14.95,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M170.51,1009.28c0,12-11.54,21.72-25.78,21.72s-25.79-9.73-25.79-21.72c0-1.16-.16-10.06,0-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.07-.18,25.78,10.42C170.67,998.94,170.51,1008.28,170.51,1009.28Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="113.41"
        cy="971.6"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="113.41"
        cy="970.11"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M170.51,972.35c0,12-11.54,21.72-25.78,21.72s-25.79-9.73-25.79-21.72c0-1.16-.16-10.07,0-11.17,1.93-10.39,12.87-10.55,25.74-10.55,13.05,0,24.07-.18,25.78,10.41C170.67,962,170.51,971.34,170.51,972.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="113.41"
        cy="934.66"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="113.41"
        cy="933.18"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M170.83,938.51c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.88,1.94-11,12.87-11.21,25.74-11.21,13.06,0,24.08-.19,25.79,11.07C171,927.52,170.83,937.44,170.83,938.51Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="113.73"
        cy="899.46"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M144.09,908.07v36.34s2.23.68,2.39,0-1.19-36.34-1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M141.92,941.26s-8.69-2.1-14.3-7.39c-5.85-5.52-8.39-13.76,4.13-21.78a28.93,28.93,0,0,1,10.17-3.65v-.85A26,26,0,0,0,131,911.32c-7.69,5-15.11,14.52-4.07,24.72a28,28,0,0,0,14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M119.27,903.78c0,12.75,11.54,23.08,25.78,23.08s25.79-10.33,25.79-23.08c0-1.23.16-10.7-.05-11.88-1.93-11-12.87-11.21-25.74-11.21-13.05,0-24.07-.2-25.78,11.07C119.11,892.79,119.27,902.71,119.27,903.78Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="113.74"
        cy="864.72"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M146,873.33v36.35s-2.23.68-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M148.18,906.53s8.69-2.1,14.3-7.39c5.85-5.52,8.39-13.76-4.13-21.78a28.73,28.73,0,0,0-10.17-3.66v-.85a26.05,26.05,0,0,1,10.87,3.74c7.69,5,15.12,14.52,4.08,24.71A27.93,27.93,0,0,1,148.18,909Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M170.51,872.46c0,12-11.54,21.72-25.78,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06,0-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.07-.18,25.78,10.42C170.67,862.13,170.51,871.46,170.51,872.46Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="113.41"
        cy="834.78"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="113.41"
        cy="833.29"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M118,839.25c0,12.75,11.55,23.09,25.79,23.09s25.79-10.34,25.79-23.09c0-1.22.16-10.69,0-11.87-1.94-11-12.87-11.21-25.74-11.21-13.05,0-24.08-.2-25.79,11.07C117.84,828.27,118,838.19,118,839.25Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="112.46"
        cy="800.2"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M144.73,808.81v36.35s-2.23.68-2.39,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M146.91,842s8.68-2.09,14.29-7.38c5.85-5.52,8.39-13.76-4.12-21.79a29.08,29.08,0,0,0-10.17-3.65v-.85a26.05,26.05,0,0,1,10.87,3.74c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M170.51,804.32c0,12-11.54,21.72-25.78,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06,0-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.07-.18,25.78,10.42C170.67,794,170.51,803.32,170.51,804.32Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="113.41"
        cy="766.64"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="113.41"
        cy="765.15"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M119.27,774.57c0,12.76,11.54,23.09,25.78,23.09s25.79-10.33,25.79-23.09c0-1.22.16-10.69-.05-11.87-1.93-11-12.87-11.21-25.74-11.21-13.05,0-24.07-.2-25.78,11.07C119.11,763.59,119.27,773.51,119.27,774.57Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="113.74"
        cy="735.52"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M146,744.13v36.35s-2.23.68-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M148.18,777.32s8.69-2.09,14.3-7.38c5.85-5.52,8.39-13.76-4.13-21.79a28.93,28.93,0,0,0-10.17-3.65v-.85a26.05,26.05,0,0,1,10.87,3.74c7.69,5,15.12,14.52,4.08,24.71a27.92,27.92,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M118,734.82c0,12.75,11.55,23.08,25.79,23.08s25.79-10.33,25.79-23.08c0-1.23.16-10.7,0-11.88-1.94-11-12.87-11.21-25.74-11.21-13.05,0-24.08-.2-25.79,11.07C117.84,723.83,118,733.75,118,734.82Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="112.46"
        cy="695.76"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M144.73,704.37v36.35s-2.23.68-2.39,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M146.91,737.57s8.68-2.1,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a28.88,28.88,0,0,0-10.17-3.66v-.85a26.05,26.05,0,0,1,10.87,3.74c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M170.51,699.89c0,12-11.54,21.72-25.78,21.72s-25.79-9.73-25.79-21.72c0-1.16-.16-10.07,0-11.17,1.93-10.39,12.87-10.55,25.74-10.55,13.05,0,24.07-.18,25.78,10.41C170.67,689.55,170.51,698.88,170.51,699.89Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="113.41"
        cy="662.2"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="113.41"
        cy="660.72"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M119.27,662.14c0,12.75,11.54,23.08,25.78,23.08s25.79-10.33,25.79-23.08c0-1.23.16-10.7-.05-11.88-1.93-11-12.87-11.21-25.74-11.21-13.05,0-24.07-.19-25.78,11.07C119.11,651.15,119.27,661.07,119.27,662.14Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="113.74"
        cy="623.09"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M146,631.69V668s-2.23.68-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M148.18,664.89s8.69-2.1,14.3-7.39c5.85-5.52,8.39-13.76-4.13-21.78a28.54,28.54,0,0,0-10.17-3.65v-.85A26,26,0,0,1,159.05,635c7.69,5,15.12,14.52,4.08,24.71a27.93,27.93,0,0,1-14.95,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M119.27,616.85c0,12.75,11.54,23.09,25.78,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.69-.05-11.87-1.93-11-12.87-11.22-25.74-11.22-13.05,0-24.07-.19-25.78,11.08C119.11,605.87,119.27,615.79,119.27,616.85Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="113.74"
        cy="577.8"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M146,586.41v36.35s-2.23.68-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M148.18,619.6s8.69-2.09,14.3-7.39c5.85-5.51,8.39-13.76-4.13-21.78a28.93,28.93,0,0,0-10.17-3.65v-.85a25.89,25.89,0,0,1,10.87,3.74c7.69,5,15.12,14.52,4.08,24.71A28,28,0,0,1,148.18,622Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M170.83,550.21c0,12.75-11.54,23.09-25.79,23.09S119.26,563,119.26,550.21c0-1.22-.16-10.69,0-11.87,1.94-11,12.87-11.21,25.74-11.21,13.06,0,24.08-.2,25.79,11.07C171,539.23,170.83,549.15,170.83,550.21Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="113.73"
        cy="511.16"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M144.09,519.77v36.35s2.23.68,2.39,0-1.19-36.35-1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M141.92,553s-8.69-2.09-14.3-7.38c-5.85-5.52-8.39-13.77,4.13-21.79a28.93,28.93,0,0,1,10.17-3.65v-.85A26.12,26.12,0,0,0,131,523c-7.69,5-15.11,14.52-4.07,24.71a28,28,0,0,0,14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M170.51,468.57c0,12-11.54,21.72-25.78,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06,0-11.16,1.93-10.39,12.87-10.55,25.74-10.55,13.05,0,24.07-.19,25.78,10.41C170.67,458.24,170.51,467.57,170.51,468.57Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="113.41"
        cy="430.89"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="113.41"
        cy="429.41"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M84.23,354.62c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.7.05-11.88,1.93-11,12.87-11.21,25.74-11.21,13,0,24.08-.19,25.79,11.07C84.38,343.63,84.23,353.55,84.23,354.62Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="27.12"
        cy="315.57"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M57.49,324.18v36.34s2.22.68,2.39,0-1.2-36.34-1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M55.31,357.37S46.63,355.27,41,350c-5.84-5.52-8.38-13.76,4.13-21.78a29,29,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.87,3.73c-7.69,5-15.11,14.52-4.08,24.71a27.93,27.93,0,0,0,15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M207.47,1041.77c0,12.75,11.54,23.09,25.78,23.09S259,1054.52,259,1041.77c0-1.23.16-10.69-.05-11.87-1.93-11-12.87-11.22-25.74-11.22-13.05,0-24.07-.19-25.78,11.08C207.31,1030.78,207.47,1040.71,207.47,1041.77Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="201.94"
        cy="1002.72"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M234.21,1011.33v36.35s-2.23.67-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M236.38,1044.52s8.69-2.09,14.3-7.39c5.84-5.51,8.39-13.76-4.13-21.78a29,29,0,0,0-10.17-3.65v-.85a25.89,25.89,0,0,1,10.87,3.74c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M207.47,1005.49c0,12.75,11.54,23.09,25.78,23.09S259,1018.24,259,1005.49c0-1.23.16-10.7-.05-11.87-1.93-11-12.87-11.22-25.74-11.22-13.05,0-24.07-.19-25.78,11.07C207.31,994.5,207.47,1004.42,207.47,1005.49Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="201.94"
        cy="966.44"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M234.21,975.05v36.34s-2.23.68-2.4,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M236.38,1008.24s8.69-2.1,14.3-7.39c5.84-5.52,8.39-13.76-4.13-21.78a29,29,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.72a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M259,961.85c0,12.75-11.55,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.87,1.94-11,12.87-11.22,25.74-11.22,13.06,0,24.08-.19,25.79,11.08C259.19,950.86,259,960.78,259,961.85Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="201.93"
        cy="922.8"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M232.29,931.41v36.34s2.23.68,2.39,0-1.19-36.34-1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M230.12,964.6s-8.69-2.09-14.3-7.39c-5.85-5.52-8.39-13.76,4.12-21.78a29.06,29.06,0,0,1,10.18-3.65v-.85a26,26,0,0,0-10.88,3.73c-7.69,5-15.11,14.53-4.07,24.72a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M258.71,930.21c0,12-11.54,21.72-25.79,21.72s-25.78-9.72-25.78-21.72c0-1.16-.16-10.06,0-11.17,1.94-10.38,12.87-10.55,25.74-10.55,13.06,0,24.08-.18,25.79,10.42C258.87,919.87,258.71,929.21,258.71,930.21Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="201.61"
        cy="892.53"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="201.61"
        cy="891.04"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M258.71,878.28c0,12-11.54,21.72-25.79,21.72s-25.78-9.73-25.78-21.72c0-1.16-.16-10.06,0-11.17,1.94-10.38,12.87-10.55,25.74-10.55,13.06,0,24.08-.18,25.79,10.42C258.87,867.94,258.71,877.28,258.71,878.28Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="201.61"
        cy="840.6"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="201.61"
        cy="839.11"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M259,819.44c0,12.75-11.55,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.87,1.94-11,12.87-11.22,25.74-11.22,13.06,0,24.08-.19,25.79,11.08C259.19,808.45,259,818.38,259,819.44Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="201.93"
        cy="780.39"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M232.29,789v36.34s2.23.68,2.39,0S233.49,789,233.49,789Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M230.12,822.19s-8.69-2.09-14.3-7.39C210,809.29,207.43,801,219.94,793a29.06,29.06,0,0,1,10.18-3.65v-.85a25.91,25.91,0,0,0-10.88,3.74c-7.69,5-15.11,14.52-4.07,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M207.47,744.71c0,12.75,11.54,23.09,25.78,23.09S259,757.46,259,744.71c0-1.23.16-10.7-.05-11.88-1.93-11-12.87-11.21-25.74-11.21-13.05,0-24.07-.19-25.78,11.07C207.31,733.72,207.47,743.64,207.47,744.71Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="201.94"
        cy="705.66"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M234.21,714.27v36.34s-2.23.68-2.4,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M236.38,747.46s8.69-2.1,14.3-7.39c5.84-5.52,8.39-13.76-4.13-21.78a29,29,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.72a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M31.39,265.36c0,12.75,11.54,23.09,25.78,23.09S83,278.11,83,265.36c0-1.23.16-10.69,0-11.87C81,242.45,70,242.27,57.17,242.27c-13.05,0-24.07-.19-25.78,11.08C31.23,254.38,31.39,264.3,31.39,265.36Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="25.86"
        cy="226.31"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M58.13,234.92v36.35s-2.23.68-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M60.3,268.11S69,266,74.6,260.73c5.84-5.52,8.39-13.77-4.13-21.79a29,29,0,0,0-10.17-3.65v-.85a26.05,26.05,0,0,1,10.87,3.74c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M83.91,175.43c0,12-11.55,21.72-25.79,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06.05-11.17,1.94-10.38,12.87-10.55,25.74-10.55,13.05,0,24.08-.18,25.79,10.42C84.06,165.1,83.91,174.43,83.91,175.43Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="26.8"
        cy="137.75"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="26.8"
        cy="136.26"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M344.71,1042.86c0,12-11.54,21.72-25.78,21.72s-25.79-9.73-25.79-21.72c0-1.16-.16-10.06.05-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.07-.18,25.78,10.42C344.87,1032.52,344.71,1041.86,344.71,1042.86Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="287.61"
        cy="1005.18"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="287.61"
        cy="1003.69"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M293.47,1013.11c0,12.75,11.54,23.09,25.78,23.09S345,1025.86,345,1013.11c0-1.23.16-10.7,0-11.87-1.94-11-12.88-11.22-25.75-11.22-13.05,0-24.07-.19-25.78,11.07C293.31,1002.12,293.47,1012,293.47,1013.11Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="287.94"
        cy="974.06"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M320.21,982.67V1019s-2.23.68-2.4,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M322.38,1015.86s8.69-2.1,14.3-7.39c5.85-5.52,8.39-13.76-4.13-21.78A28.93,28.93,0,0,0,322.38,983v-.85a26,26,0,0,1,10.87,3.73c7.7,5,15.12,14.52,4.08,24.72a28,28,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M292.19,973.35c0,12.75,11.55,23.09,25.79,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.87-1.94-11-12.87-11.22-25.74-11.22-13.05,0-24.08-.19-25.79,11.08C292,962.36,292.19,972.29,292.19,973.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="286.66"
        cy="934.3"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M318.93,942.91v36.34s-2.23.68-2.39,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M321.11,976.1s8.68-2.09,14.29-7.39c5.85-5.51,8.39-13.76-4.12-21.78a29.08,29.08,0,0,0-10.17-3.65v-.85A25.89,25.89,0,0,1,332,946.17c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M344.71,938.42c0,12-11.54,21.72-25.78,21.72s-25.79-9.72-25.79-21.72c0-1.16-.16-10.06.05-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.07-.18,25.78,10.42C344.87,928.08,344.71,937.42,344.71,938.42Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="287.61"
        cy="900.74"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="287.61"
        cy="899.25"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M293.47,908.67c0,12.75,11.54,23.09,25.78,23.09S345,921.42,345,908.67c0-1.23.16-10.7,0-11.87-1.94-11-12.88-11.22-25.75-11.22-13.05,0-24.07-.19-25.78,11.08C293.31,897.68,293.47,907.61,293.47,908.67Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="287.94"
        cy="869.62"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M320.21,878.23v36.34s-2.23.68-2.4,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M322.38,911.42s8.69-2.09,14.3-7.39c5.85-5.51,8.39-13.76-4.13-21.78a28.93,28.93,0,0,0-10.17-3.65v-.85a25.89,25.89,0,0,1,10.87,3.74c7.7,5,15.12,14.52,4.08,24.71a28,28,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M293.47,872.39c0,12.75,11.54,23.08,25.78,23.08S345,885.14,345,872.39c0-1.23.16-10.7,0-11.88-1.94-11-12.88-11.21-25.75-11.21-13.05,0-24.07-.19-25.78,11.07C293.31,861.4,293.47,871.32,293.47,872.39Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="287.94"
        cy="833.34"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M320.21,841.94v36.35s-2.23.68-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M322.38,875.14s8.69-2.1,14.3-7.39c5.85-5.52,8.39-13.76-4.13-21.78a28.73,28.73,0,0,0-10.17-3.66v-.84a26,26,0,0,1,10.87,3.73c7.7,5,15.12,14.52,4.08,24.71a27.93,27.93,0,0,1-14.95,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M345,828.75c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.88,1.94-11,12.87-11.21,25.74-11.21,13.06,0,24.08-.19,25.79,11.07C345.19,817.76,345,827.68,345,828.75Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="287.93"
        cy="789.7"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M318.29,798.3v36.35s2.23.68,2.39,0-1.19-36.35-1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M316.12,831.5s-8.69-2.1-14.3-7.39c-5.85-5.52-8.39-13.76,4.13-21.78a28.54,28.54,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.88,3.73c-7.69,5-15.11,14.52-4.07,24.71a27.93,27.93,0,0,0,14.95,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M344.71,787.11c0,12-11.54,21.72-25.78,21.72s-25.79-9.73-25.79-21.72c0-1.16-.16-10.06.05-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.07-.18,25.78,10.42C344.87,776.77,344.71,786.11,344.71,787.11Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="287.61"
        cy="749.43"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="287.61"
        cy="747.94"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M344.71,730.18c0,12-11.54,21.72-25.78,21.72s-25.79-9.73-25.79-21.72c0-1.16-.16-10.07.05-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.07-.18,25.78,10.42C344.87,719.84,344.71,729.18,344.71,730.18Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="287.61"
        cy="692.49"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="287.61"
        cy="691.01"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M345,676.34c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.87,1.94-11,12.87-11.22,25.74-11.22,13.06,0,24.08-.19,25.79,11.08C345.19,665.35,345,675.27,345,676.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="287.93"
        cy="637.29"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M318.29,645.9v36.34s2.23.68,2.39,0-1.19-36.34-1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M316.12,679.09s-8.69-2.09-14.3-7.39c-5.85-5.52-8.39-13.76,4.13-21.78a28.93,28.93,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.88,3.73c-7.69,5-15.11,14.53-4.07,24.72a28,28,0,0,0,14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M293.47,611.61c0,12.75,11.54,23.08,25.78,23.08S345,624.36,345,611.61c0-1.23.16-10.7,0-11.88-1.94-11-12.88-11.21-25.75-11.21-13.05,0-24.07-.19-25.78,11.07C293.31,600.62,293.47,610.54,293.47,611.61Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="287.94"
        cy="572.56"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M320.21,581.16v36.35s-2.23.68-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M322.38,614.36s8.69-2.1,14.3-7.39c5.85-5.52,8.39-13.76-4.13-21.78a28.73,28.73,0,0,0-10.17-3.66v-.84a26,26,0,0,1,10.87,3.73c7.7,5,15.12,14.52,4.08,24.71a27.93,27.93,0,0,1-14.95,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M431,1042.55c0,12-11.54,21.72-25.78,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06.05-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.07-.18,25.78,10.42C431.19,1032.22,431,1041.55,431,1042.55Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="373.93"
        cy="1004.87"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="373.93"
        cy="1003.38"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M379.79,1012.8c0,12.75,11.54,23.09,25.78,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.69-.05-11.87-1.93-11-12.87-11.22-25.74-11.22-13.05,0-24.07-.19-25.78,11.08C379.63,1001.82,379.79,1011.74,379.79,1012.8Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="374.26"
        cy="973.75"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M406.53,982.36v36.35s-2.23.68-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M408.7,1015.55s8.69-2.09,14.3-7.39c5.84-5.51,8.39-13.76-4.13-21.78a28.93,28.93,0,0,0-10.17-3.65v-.85a25.89,25.89,0,0,1,10.87,3.74c7.69,5,15.12,14.52,4.08,24.71A28,28,0,0,1,408.7,1018Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M379.79,976.52c0,12.75,11.54,23.09,25.78,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7-.05-11.87-1.93-11-12.87-11.22-25.74-11.22-13.05,0-24.07-.19-25.78,11.08C379.63,965.53,379.79,975.45,379.79,976.52Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="374.26"
        cy="937.47"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M406.53,946.08v36.34s-2.23.68-2.4,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M408.7,979.27s8.69-2.09,14.3-7.39c5.84-5.52,8.39-13.76-4.13-21.78a28.93,28.93,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.12,14.53,4.08,24.72a28,28,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M431.35,932.88c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.87,1.94-11,12.87-11.22,25.74-11.22,13.06,0,24.08-.19,25.79,11.08C431.51,921.89,431.35,931.82,431.35,932.88Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="374.25"
        cy="893.83"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M404.61,902.44v36.34s2.23.68,2.39,0-1.19-36.34-1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M402.44,935.63s-8.69-2.09-14.3-7.39c-5.85-5.51-8.39-13.76,4.13-21.78a28.93,28.93,0,0,1,10.17-3.65V902a26,26,0,0,0-10.88,3.74c-7.69,4.95-15.11,14.52-4.07,24.71a28,28,0,0,0,14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M431,901.24c0,12-11.54,21.72-25.78,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06.05-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.07-.18,25.78,10.42C431.19,890.91,431,900.24,431,901.24Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="373.93"
        cy="863.56"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="373.93"
        cy="862.07"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M431,864.31c0,12-11.54,21.72-25.78,21.72s-25.79-9.73-25.79-21.72c0-1.16-.16-10.06.05-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.07-.18,25.78,10.42C431.19,854,431,863.31,431,864.31Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="373.93"
        cy="826.63"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="373.93"
        cy="825.14"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M431.35,830.47c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.87,1.94-11,12.87-11.22,25.74-11.22,13.06,0,24.08-.19,25.79,11.08C431.51,819.48,431.35,829.41,431.35,830.47Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="374.25"
        cy="791.42"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M404.61,800v36.34s2.23.68,2.39,0S405.81,800,405.81,800Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M402.44,833.22s-8.69-2.09-14.3-7.39c-5.85-5.51-8.39-13.76,4.13-21.78a28.93,28.93,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.88,3.74c-7.69,5-15.11,14.52-4.07,24.71a28,28,0,0,0,14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M379.79,785.74c0,12.75,11.54,23.09,25.78,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7-.05-11.87-1.93-11-12.87-11.22-25.74-11.22-13.05,0-24.07-.19-25.78,11.08C379.63,774.75,379.79,784.67,379.79,785.74Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="374.26"
        cy="746.69"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M406.53,755.3v36.34s-2.23.68-2.4,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M408.7,788.49s8.69-2.09,14.3-7.39c5.84-5.52,8.39-13.76-4.13-21.78a28.93,28.93,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.12,14.53,4.08,24.72a28,28,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M344.71,540.29c0,12-11.54,21.72-25.78,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06.05-11.16,1.93-10.39,12.87-10.55,25.74-10.55,13.05,0,24.07-.19,25.78,10.41C344.87,530,344.71,539.29,344.71,540.29Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="287.61"
        cy="502.61"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="287.61"
        cy="501.12"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M292.19,457.08c0,12.76,11.55,23.09,25.79,23.09s25.79-10.33,25.79-23.09c0-1.22.16-10.69,0-11.87C341.78,434.18,330.85,434,318,434c-13.05,0-24.08-.2-25.79,11.07C292,446.1,292.19,456,292.19,457.08Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="286.66"
        cy="418.03"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M318.93,426.64V463s-2.23.68-2.39,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M321.11,459.83s8.68-2.09,14.29-7.38c5.85-5.52,8.39-13.76-4.12-21.79A29.08,29.08,0,0,0,321.11,427v-.85A26.05,26.05,0,0,1,332,429.9c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M344.71,362.15c0,12-11.54,21.72-25.78,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06.05-11.16,1.93-10.39,12.87-10.55,25.74-10.55,13.05,0,24.07-.19,25.78,10.41C344.87,351.82,344.71,361.15,344.71,362.15Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="287.61"
        cy="324.47"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="287.61"
        cy="322.99"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M32.66,76.68c0,12.76,11.55,23.09,25.79,23.09S84.24,89.44,84.24,76.68c0-1.22.16-10.69,0-11.87-1.94-11-12.87-11.21-25.74-11.21-13.05,0-24.08-.2-25.79,11.07C32.51,65.7,32.66,75.62,32.66,76.68Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="27.13"
        cy="37.63"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M59.4,46.24V82.59s-2.23.68-2.39,0S58.2,46.24,58.2,46.24Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M61.58,79.43s8.68-2.09,14.29-7.38c5.85-5.52,8.39-13.76-4.12-21.79a29.08,29.08,0,0,0-10.17-3.65v-.85A26.05,26.05,0,0,1,72.45,49.5c7.69,5,15.11,14.52,4.07,24.71a27.89,27.89,0,0,1-14.94,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M431.23,745.91c0,12.75-11.54,23.09-25.78,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.7,0-11.88,1.93-11,12.87-11.21,25.74-11.21,13.05,0,24.07-.19,25.78,11.07C431.39,734.92,431.23,744.84,431.23,745.91Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="374.13"
        cy="706.86"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M404.49,715.46v36.35s2.23.68,2.4,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M402.32,748.66s-8.69-2.1-14.3-7.39c-5.84-5.52-8.39-13.76,4.13-21.78a28.61,28.61,0,0,1,10.17-3.65V715a26,26,0,0,0-10.87,3.73c-7.69,5-15.11,14.52-4.08,24.71a27.93,27.93,0,0,0,14.95,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M379.67,701.17c0,12.76,11.55,23.09,25.79,23.09s25.78-10.33,25.78-23.09c0-1.22.16-10.69,0-11.87-1.94-11-12.87-11.21-25.74-11.21-13.06,0-24.08-.2-25.79,11.07C379.51,690.19,379.67,700.11,379.67,701.17Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="374.14"
        cy="662.12"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M406.41,670.73v36.35s-2.23.68-2.39,0,1.19-36.35,1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M408.58,703.92s8.69-2.09,14.3-7.38c5.85-5.52,8.39-13.76-4.13-21.79a28.93,28.93,0,0,0-10.17-3.65v-.85A26.07,26.07,0,0,1,419.46,674c7.69,5,15.11,14.52,4.07,24.71a27.89,27.89,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M430.92,649.86c0,12-11.55,21.72-25.79,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06.05-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.08-.18,25.79,10.42C431.07,639.53,430.92,648.86,430.92,649.86Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="373.81"
        cy="612.18"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="373.81"
        cy="610.69"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M378.39,586.65c0,12.75,11.55,23.09,25.79,23.09S430,599.4,430,586.65c0-1.23.16-10.69-.05-11.87-1.93-11-12.87-11.22-25.74-11.22-13.05,0-24.08-.19-25.79,11.08C378.24,575.67,378.39,585.59,378.39,586.65Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="372.87"
        cy="547.6"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M405.13,556.21v36.35s-2.22.68-2.39,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M407.31,589.4s8.68-2.09,14.3-7.39c5.84-5.51,8.38-13.76-4.13-21.78a29,29,0,0,0-10.17-3.65v-.85a25.89,25.89,0,0,1,10.87,3.74c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M430.92,521.72c0,12-11.55,21.72-25.79,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06.05-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.08-.18,25.79,10.42C431.07,511.39,430.92,520.72,430.92,521.72Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="373.81"
        cy="484.04"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="373.81"
        cy="482.55"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M379.67,432c0,12.76,11.55,23.09,25.79,23.09s25.78-10.33,25.78-23.09c0-1.22.16-10.69,0-11.87-1.94-11-12.87-11.21-25.74-11.21-13.06,0-24.08-.2-25.79,11.07C379.51,421,379.67,430.91,379.67,432Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="374.14"
        cy="392.92"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M406.41,401.53v36.35s-2.23.68-2.39,0,1.19-36.35,1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M408.58,434.72s8.69-2.09,14.3-7.38c5.85-5.52,8.39-13.76-4.13-21.79a28.93,28.93,0,0,0-10.17-3.65v-.85a26.07,26.07,0,0,1,10.88,3.74c7.69,5,15.11,14.52,4.07,24.71a27.89,27.89,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M815.72,1043.56c0,12.75,11.54,23.09,25.79,23.09s25.78-10.34,25.78-23.09c0-1.22.16-10.69,0-11.87-1.94-11-12.87-11.21-25.74-11.21-13.06,0-24.08-.2-25.79,11.07C815.56,1032.58,815.72,1042.5,815.72,1043.56Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="810.19"
        cy="1004.51"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M842.46,1013.12v36.35s-2.23.68-2.39,0,1.19-36.35,1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M844.63,1046.31s8.69-2.09,14.3-7.38c5.85-5.52,8.39-13.76-4.13-21.79a28.93,28.93,0,0,0-10.17-3.65v-.85a26.07,26.07,0,0,1,10.88,3.74c7.69,5,15.11,14.52,4.07,24.71a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M867,1002.25c0,12-11.55,21.72-25.79,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06.05-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.08-.18,25.79,10.42C867.12,991.92,867,1001.25,867,1002.25Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="809.86"
        cy="964.57"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="809.86"
        cy="963.08"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M893.37,1043c0,12.75,11.54,23.09,25.79,23.09s25.78-10.34,25.78-23.09c0-1.23.16-10.69,0-11.87-1.94-11-12.87-11.22-25.74-11.22-13.06,0-24.08-.19-25.79,11.08C893.21,1032.05,893.37,1042,893.37,1043Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="887.84"
        cy="1003.98"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M920.11,1012.59v36.35s-2.23.68-2.39,0,1.19-36.35,1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M922.28,1045.78s8.69-2.09,14.3-7.38c5.85-5.52,8.39-13.77-4.13-21.79a28.93,28.93,0,0,0-10.17-3.65v-.85a26.12,26.12,0,0,1,10.88,3.74c7.69,5,15.11,14.52,4.07,24.71a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M945.89,988.1c0,12-11.55,21.72-25.79,21.72s-25.78-9.72-25.78-21.72c0-1.15-.16-10.06,0-11.17,1.94-10.38,12.87-10.55,25.74-10.55,13.06,0,24.08-.18,25.79,10.42C946.05,977.77,945.89,987.1,945.89,988.1Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="888.79"
        cy="950.42"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="888.79"
        cy="948.93"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M894.64,918.35c0,12.76,11.55,23.09,25.79,23.09s25.79-10.33,25.79-23.09c0-1.22.16-10.69-.05-11.87-1.93-11-12.87-11.21-25.74-11.21-13,0-24.08-.2-25.79,11.07C894.49,907.37,894.64,917.29,894.64,918.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="889.11"
        cy="879.3"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M921.38,887.91v36.35s-2.23.68-2.39,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M923.56,921.1s8.68-2.09,14.3-7.38c5.84-5.52,8.38-13.76-4.13-21.79a29,29,0,0,0-10.17-3.65v-.85a26.05,26.05,0,0,1,10.87,3.74c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1203,1042.58c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.7.05-11.87,1.94-11,12.87-11.22,25.74-11.22,13,0,24.08-.19,25.79,11.08C1203.1,1031.59,1203,1041.52,1203,1042.58Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1145.84"
        cy="1003.53"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1176.21,1012.14v36.34s2.23.68,2.39,0-1.2-36.34-1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1174,1045.33s-8.68-2.09-14.29-7.39c-5.85-5.51-8.39-13.76,4.12-21.78a29.08,29.08,0,0,1,10.17-3.65v-.85a25.89,25.89,0,0,0-10.87,3.74c-7.69,5-15.11,14.52-4.08,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1151.38,1007.85c0,12.75,11.55,23.09,25.79,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.87-1.93-11-12.87-11.22-25.74-11.22-13.05,0-24.08-.19-25.79,11.07C1151.23,996.86,1151.38,1006.78,1151.38,1007.85Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1145.85"
        cy="968.8"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1178.12,977.41v36.34s-2.23.68-2.39,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1180.3,1010.6s8.68-2.1,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a29.08,29.08,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.72a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1202.63,976.54c0,12-11.55,21.72-25.79,21.72s-25.79-9.73-25.79-21.72c0-1.16-.15-10.07,0-11.17,1.94-10.38,12.87-10.55,25.74-10.55,13.06,0,24.08-.18,25.79,10.42C1202.79,966.2,1202.63,975.54,1202.63,976.54Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1145.53"
        cy="938.85"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1145.53"
        cy="937.37"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1150.11,923.33c0,12.75,11.54,23.08,25.79,23.08s25.78-10.33,25.78-23.08c0-1.23.16-10.7,0-11.88-1.94-11-12.87-11.21-25.74-11.21-13.06,0-24.08-.19-25.79,11.07C1150,912.34,1150.11,922.26,1150.11,923.33Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1144.58"
        cy="884.28"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1176.85,892.88v36.35s-2.23.68-2.39,0,1.19-36.35,1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1179,926.08s8.69-2.1,14.3-7.39c5.85-5.52,8.39-13.76-4.13-21.78a28.54,28.54,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.7,5,15.12,14.52,4.08,24.71a27.93,27.93,0,0,1-15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1202.63,858.4c0,12-11.55,21.72-25.79,21.72s-25.79-9.73-25.79-21.72c0-1.16-.15-10.07,0-11.17,1.94-10.38,12.87-10.55,25.74-10.55,13.06,0,24.08-.18,25.79,10.42C1202.79,848.06,1202.63,857.4,1202.63,858.4Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1145.53"
        cy="820.71"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1145.53"
        cy="819.23"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1151.38,788.65c0,12.75,11.55,23.09,25.79,23.09S1203,801.4,1203,788.65c0-1.23.16-10.7,0-11.88-1.93-11-12.87-11.21-25.74-11.21-13.05,0-24.08-.19-25.79,11.07C1151.23,777.66,1151.38,787.58,1151.38,788.65Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1145.85"
        cy="749.6"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1178.12,758.21v36.34s-2.23.68-2.39,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1180.3,791.4s8.68-2.1,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a29.08,29.08,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M378.39,312.21c0,12.76,11.55,23.09,25.79,23.09S430,325,430,312.21c0-1.22.16-10.69-.05-11.87-1.93-11-12.87-11.21-25.74-11.21-13.05,0-24.08-.2-25.79,11.07C378.24,301.23,378.39,311.15,378.39,312.21Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="372.87"
        cy="273.16"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M405.13,281.77v36.35s-2.22.68-2.39,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M407.31,315s8.68-2.09,14.3-7.38c5.84-5.52,8.38-13.76-4.13-21.78a28.8,28.8,0,0,0-10.17-3.66v-.85A26.05,26.05,0,0,1,418.18,285c7.69,5,15.11,14.52,4.08,24.71a27.93,27.93,0,0,1-14.95,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M467.5,1043c0,12.75,11.54,23.09,25.79,23.09s25.78-10.34,25.78-23.09c0-1.23.16-10.7,0-11.87-1.94-11-12.87-11.22-25.74-11.22-13.06,0-24.08-.19-25.79,11.08C467.34,1032,467.5,1041.92,467.5,1043Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="461.97"
        cy="1003.93"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M494.24,1012.54v36.34s-2.23.68-2.39,0,1.19-36.34,1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M496.41,1045.73s8.69-2.09,14.3-7.39c5.85-5.51,8.39-13.76-4.13-21.78a28.93,28.93,0,0,0-10.17-3.65v-.85a25.89,25.89,0,0,1,10.87,3.74c7.7,5,15.12,14.52,4.08,24.71a28,28,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M519,1003.15c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.7.05-11.87,1.93-11,12.87-11.22,25.74-11.22,13,0,24.08-.19,25.79,11.07C519.1,992.16,519,1002.08,519,1003.15Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="461.84"
        cy="964.1"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M492.21,972.71v36.34s2.23.68,2.39,0-1.2-36.34-1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M490,1005.9s-8.68-2.09-14.3-7.39c-5.84-5.52-8.38-13.76,4.13-21.78A29,29,0,0,1,490,973.08v-.85A26,26,0,0,0,479.16,976c-7.69,5-15.11,14.52-4.08,24.72a28,28,0,0,0,14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M467.38,948.42c0,12.75,11.55,23.08,25.79,23.08S519,961.17,519,948.42c0-1.23.16-10.7-.05-11.88-1.94-11-12.87-11.21-25.74-11.21-13.05,0-24.08-.19-25.79,11.07C467.23,937.43,467.38,947.35,467.38,948.42Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="461.85"
        cy="909.37"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M494.12,918v36.35s-2.23.68-2.39,0S492.92,918,492.92,918Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M496.3,951.17s8.68-2.1,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a28.88,28.88,0,0,0-10.17-3.66v-.84a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-14.95,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M518.63,897.1c0,12-11.55,21.72-25.79,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06.05-11.16,1.94-10.39,12.87-10.55,25.74-10.55,13.05,0,24.08-.19,25.79,10.41C518.78,886.77,518.63,896.1,518.63,897.1Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="461.52"
        cy="859.42"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="461.52"
        cy="857.93"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M466.11,833.89c0,12.76,11.54,23.09,25.78,23.09s25.79-10.33,25.79-23.09c0-1.22.16-10.69,0-11.87-1.93-11-12.87-11.21-25.74-11.21-13.05,0-24.07-.2-25.78,11.07C466,822.91,466.11,832.83,466.11,833.89Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="460.58"
        cy="794.84"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M492.85,803.45V839.8s-2.23.68-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M495,836.64s8.69-2.09,14.3-7.38c5.84-5.52,8.39-13.76-4.13-21.79A28.93,28.93,0,0,0,495,803.82V803a26.05,26.05,0,0,1,10.87,3.74c7.69,5,15.11,14.52,4.08,24.71a27.92,27.92,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M518.63,759c0,12-11.55,21.72-25.79,21.72S467.05,771,467.05,759c0-1.15-.16-10.06.05-11.16,1.94-10.39,12.87-10.55,25.74-10.55,13.05,0,24.08-.19,25.79,10.41C518.78,748.63,518.63,758,518.63,759Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="461.52"
        cy="721.28"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="461.52"
        cy="719.79"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M467.38,679.22c0,12.75,11.55,23.08,25.79,23.08S519,692,519,679.22c0-1.23.16-10.7-.05-11.88-1.94-11-12.87-11.21-25.74-11.21-13.05,0-24.08-.2-25.79,11.07C467.23,668.23,467.38,678.15,467.38,679.22Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="461.85"
        cy="640.16"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M494.12,648.77v36.35s-2.23.68-2.39,0,1.19-36.35,1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M496.3,682s8.68-2.1,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a28.88,28.88,0,0,0-10.17-3.66v-.85A26.05,26.05,0,0,1,507.17,652c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-14.95,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M553.7,1043.07c0,12.76,11.55,23.09,25.79,23.09s25.79-10.33,25.79-23.09c0-1.22.16-10.69,0-11.87-1.94-11-12.87-11.21-25.74-11.21-13.06,0-24.08-.2-25.79,11.07C553.54,1032.09,553.7,1042,553.7,1043.07Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="548.17"
        cy="1004.02"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M580.44,1012.63V1049s-2.23.68-2.39,0,1.19-36.35,1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M582.61,1045.82s8.69-2.09,14.3-7.38c5.85-5.52,8.39-13.76-4.12-21.78a28.86,28.86,0,0,0-10.18-3.66v-.85a26.07,26.07,0,0,1,10.88,3.74c7.69,5,15.11,14.52,4.07,24.71a27.89,27.89,0,0,1-14.95,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M605,1011.76c0,12-11.55,21.72-25.79,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06,0-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.08-.18,25.79,10.42C605.1,1001.43,605,1010.76,605,1011.76Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="547.84"
        cy="974.08"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="547.84"
        cy="972.59"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M552.43,968.55c0,12.75,11.54,23.09,25.78,23.09S604,981.3,604,968.55c0-1.23.16-10.69,0-11.87-1.93-11-12.87-11.22-25.74-11.22-13.05,0-24.07-.19-25.78,11.08C552.27,957.57,552.43,967.49,552.43,968.55Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="546.9"
        cy="929.5"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M579.17,938.11v36.35s-2.23.68-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M581.34,971.3s8.69-2.09,14.3-7.38c5.84-5.52,8.39-13.77-4.13-21.79a29,29,0,0,0-10.17-3.65v-.85a25.89,25.89,0,0,1,10.87,3.74c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M605,903.62c0,12-11.55,21.72-25.79,21.72s-25.79-9.72-25.79-21.72c0-1.15-.16-10.06,0-11.17,1.93-10.38,12.87-10.55,25.74-10.55,13.05,0,24.08-.18,25.79,10.42C605.1,893.29,605,902.62,605,903.62Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="547.84"
        cy="865.94"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="547.84"
        cy="864.45"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M553.7,823.87c0,12.76,11.55,23.09,25.79,23.09s25.79-10.33,25.79-23.09c0-1.22.16-10.69,0-11.87-1.94-11-12.87-11.21-25.74-11.21-13.06,0-24.08-.2-25.79,11.07C553.54,812.89,553.7,822.81,553.7,823.87Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="548.17"
        cy="784.82"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M580.44,793.43v36.35s-2.23.68-2.39,0,1.19-36.35,1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M582.61,826.62s8.69-2.09,14.3-7.38c5.85-5.52,8.39-13.76-4.12-21.79a29.06,29.06,0,0,0-10.18-3.65V793a26.07,26.07,0,0,1,10.88,3.74c7.69,5,15.11,14.52,4.07,24.71A27.89,27.89,0,0,1,582.61,829Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M466.11,579.46c0,12.75,11.54,23.08,25.78,23.08s25.79-10.33,25.79-23.08c0-1.23.16-10.7,0-11.88-1.93-11-12.87-11.21-25.74-11.21-13.05,0-24.07-.19-25.78,11.07C466,568.47,466.11,578.39,466.11,579.46Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="460.58"
        cy="540.41"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M492.85,549v36.35s-2.23.68-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M495,582.21s8.69-2.1,14.3-7.39c5.84-5.52,8.39-13.76-4.13-21.78A28.73,28.73,0,0,0,495,549.38v-.84a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.71a27.93,27.93,0,0,1-15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1460.25,1043.45c0,12.75-11.55,23.08-25.79,23.08s-25.79-10.33-25.79-23.08c0-1.23-.16-10.7,0-11.88,1.93-11,12.87-11.21,25.74-11.21,13,0,24.08-.19,25.79,11.07C1460.4,1032.46,1460.25,1042.38,1460.25,1043.45Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1403.14"
        cy="1004.4"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1433.51,1013v36.35s2.23.68,2.39,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1431.33,1046.2s-8.68-2.1-14.3-7.39c-5.84-5.52-8.38-13.76,4.13-21.78a28.8,28.8,0,0,1,10.17-3.66v-.84a26,26,0,0,0-10.87,3.73c-7.69,5-15.11,14.52-4.08,24.71a27.93,27.93,0,0,0,14.95,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1408.68,999.81c0,12.75,11.55,23.09,25.79,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.88-1.94-11-12.87-11.21-25.74-11.21-13,0-24.08-.19-25.79,11.07C1408.53,988.82,1408.68,998.74,1408.68,999.81Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1403.15"
        cy="960.76"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1435.42,969.36v36.35s-2.23.68-2.39,0,1.19-36.35,1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1437.6,1002.56s8.68-2.1,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a28.69,28.69,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1409,968.17c0,12,11.54,21.72,25.79,21.72s25.78-9.73,25.78-21.72c0-1.16.16-10.06,0-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.06,0-24.08-.18-25.79,10.42C1408.84,957.83,1409,967.17,1409,968.17Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1403.47"
        cy="930.49"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1403.47"
        cy="929"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1409,916.24c0,12,11.54,21.72,25.79,21.72s25.78-9.73,25.78-21.72c0-1.16.16-10.07,0-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.06,0-24.08-.18-25.79,10.42C1408.84,905.9,1409,915.24,1409,916.24Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1403.47"
        cy="878.55"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1403.47"
        cy="877.07"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1408.68,857.4c0,12.75,11.55,23.09,25.79,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.87-1.94-11-12.87-11.22-25.74-11.22-13,0-24.08-.19-25.79,11.07C1408.53,846.41,1408.68,856.33,1408.68,857.4Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1403.15"
        cy="818.35"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1435.42,827V863.3s-2.23.68-2.39,0,1.19-36.34,1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1437.6,860.15s8.68-2.1,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a29.08,29.08,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.72a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1460.25,782.67c0,12.75-11.55,23.08-25.79,23.08s-25.79-10.33-25.79-23.08c0-1.23-.16-10.7,0-11.88,1.93-11,12.87-11.21,25.74-11.21,13,0,24.08-.19,25.79,11.07C1460.4,771.68,1460.25,781.6,1460.25,782.67Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1403.14"
        cy="743.61"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1433.51,752.22v36.35s2.23.68,2.39,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1431.33,785.42s-8.68-2.1-14.3-7.39c-5.84-5.52-8.38-13.76,4.13-21.78a28.8,28.8,0,0,1,10.17-3.66v-.84a26,26,0,0,0-10.87,3.73c-7.69,5-15.11,14.52-4.08,24.71a27.93,27.93,0,0,0,14.95,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1800.63,1042.06c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.88,1.94-11,12.87-11.21,25.74-11.21,13.06,0,24.08-.19,25.79,11.07C1800.79,1031.07,1800.63,1041,1800.63,1042.06Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1743.53"
        cy="1003.01"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1773.89,1011.61V1048s2.23.68,2.39,0-1.19-36.35-1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1771.72,1044.81s-8.69-2.1-14.3-7.39c-5.85-5.52-8.39-13.76,4.13-21.78a28.54,28.54,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.88,3.73c-7.69,5-15.11,14.52-4.07,24.71a27.89,27.89,0,0,0,15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1801.91,1002.3c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.7.05-11.87,1.93-11,12.87-11.22,25.74-11.22,13.05,0,24.08-.19,25.79,11.07C1802.06,991.31,1801.91,1001.23,1801.91,1002.3Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1744.8"
        cy="963.25"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1775.17,971.86v36.34s2.23.68,2.39,0-1.2-36.34-1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1773,1005.05s-8.68-2.1-14.3-7.39c-5.84-5.52-8.38-13.76,4.13-21.78a29,29,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.87,3.73c-7.69,5-15.11,14.52-4.08,24.72a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1749.38,957.37c0,12,11.55,21.72,25.79,21.72s25.79-9.73,25.79-21.72c0-1.16.16-10.06,0-11.17-1.93-10.38-12.87-10.55-25.74-10.55-13.05,0-24.08-.18-25.79,10.42C1749.23,947,1749.38,956.37,1749.38,957.37Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1743.85"
        cy="919.69"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1743.85"
        cy="918.2"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1800.63,907.62c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.87,1.94-11,12.87-11.22,25.74-11.22,13.06,0,24.08-.19,25.79,11.08C1800.79,896.63,1800.63,906.55,1800.63,907.62Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1743.53"
        cy="868.57"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1773.89,877.18v36.34s2.23.68,2.39,0-1.19-36.34-1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1771.72,910.37s-8.69-2.09-14.3-7.39c-5.85-5.52-8.39-13.76,4.13-21.78a28.93,28.93,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.88,3.73c-7.69,5-15.11,14.53-4.07,24.72a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1800.63,851.34c0,12.75-11.54,23.08-25.79,23.08s-25.78-10.33-25.78-23.08c0-1.23-.16-10.7,0-11.88,1.94-11,12.87-11.21,25.74-11.21,13.06,0,24.08-.2,25.79,11.07C1800.79,840.35,1800.63,850.27,1800.63,851.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1743.53"
        cy="812.28"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1773.89,820.89v36.35s2.23.68,2.39,0-1.19-36.35-1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1771.72,854.09s-8.69-2.1-14.3-7.39c-5.85-5.52-8.39-13.76,4.13-21.78a28.73,28.73,0,0,1,10.17-3.66v-.85a26.07,26.07,0,0,0-10.88,3.74c-7.69,5-15.11,14.52-4.07,24.71a27.89,27.89,0,0,0,15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1749.07,787.7c0,12.75,11.54,23.08,25.78,23.08s25.79-10.33,25.79-23.08c0-1.23.16-10.7-.05-11.88-1.93-11-12.87-11.21-25.74-11.21-13,0-24.07-.19-25.78,11.07C1748.91,776.71,1749.07,786.63,1749.07,787.7Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1743.54"
        cy="748.65"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1775.81,757.25V793.6s-2.23.68-2.4,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1778,790.45s8.69-2.1,14.3-7.39c5.84-5.52,8.39-13.76-4.13-21.78a28.73,28.73,0,0,0-10.17-3.66v-.84a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.71a27.93,27.93,0,0,1-15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1749.38,706.06c0,12,11.55,21.72,25.79,21.72s25.79-9.73,25.79-21.72c0-1.16.16-10.06,0-11.17-1.93-10.38-12.87-10.55-25.74-10.55-13.05,0-24.08-.18-25.79,10.42C1749.23,695.72,1749.38,705.06,1749.38,706.06Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1743.85"
        cy="668.38"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1743.85"
        cy="666.89"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1749.38,589.13c0,12,11.55,21.72,25.79,21.72s25.79-9.73,25.79-21.72c0-1.16.16-10.07,0-11.17-1.93-10.39-12.87-10.55-25.74-10.55-13.05,0-24.08-.19-25.79,10.41C1749.23,578.79,1749.38,588.12,1749.38,589.13Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1743.85"
        cy="551.44"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1743.85"
        cy="549.96"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1714.31,1042.75c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.87,1.94-11,12.87-11.22,25.74-11.22,13.06,0,24.08-.19,25.79,11.08C1714.47,1031.76,1714.31,1041.69,1714.31,1042.75Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1657.21"
        cy="1003.7"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1687.57,1012.31v36.34s2.23.68,2.39,0-1.19-36.34-1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1685.4,1045.5s-8.69-2.09-14.3-7.39c-5.85-5.51-8.39-13.76,4.13-21.78a28.93,28.93,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.88,3.74c-7.69,5-15.11,14.52-4.07,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1714.31,1006.47c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.88,1.94-11,12.87-11.21,25.74-11.21,13.06,0,24.08-.19,25.79,11.07C1714.47,995.48,1714.31,1005.4,1714.31,1006.47Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1657.21"
        cy="967.42"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1687.57,976v36.34s2.23.68,2.39,0-1.19-36.34-1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1685.4,1009.22s-8.69-2.1-14.3-7.39c-5.85-5.52-8.39-13.76,4.13-21.78a28.93,28.93,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.88,3.73c-7.69,5-15.11,14.52-4.07,24.72a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1662.75,962.83c0,12.75,11.54,23.09,25.78,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.87-1.93-11-12.87-11.22-25.74-11.22-13,0-24.07-.19-25.78,11.08C1662.59,951.84,1662.75,961.76,1662.75,962.83Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1657.22"
        cy="923.78"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1689.49,932.39v36.34s-2.23.68-2.4,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1691.66,965.58s8.69-2.09,14.3-7.39c5.84-5.52,8.39-13.76-4.13-21.78a28.93,28.93,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.12,14.52,4.08,24.72a28,28,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1663.06,931.19c0,12,11.55,21.72,25.79,21.72s25.79-9.72,25.79-21.72c0-1.16.16-10.06-.05-11.17-1.93-10.38-12.87-10.55-25.74-10.55-13,0-24.08-.18-25.79,10.42C1662.91,920.85,1663.06,930.19,1663.06,931.19Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1657.54"
        cy="893.51"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1657.54"
        cy="892.02"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1663.06,894.26c0,12,11.55,21.72,25.79,21.72s25.79-9.73,25.79-21.72c0-1.16.16-10.06-.05-11.17-1.93-10.38-12.87-10.55-25.74-10.55-13,0-24.08-.18-25.79,10.42C1662.91,883.92,1663.06,893.26,1663.06,894.26Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1657.54"
        cy="856.58"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1657.54"
        cy="855.09"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1662.75,860.42c0,12.75,11.54,23.09,25.78,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.87-1.93-11-12.87-11.22-25.74-11.22-13,0-24.07-.19-25.78,11.08C1662.59,849.43,1662.75,859.36,1662.75,860.42Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1657.22"
        cy="821.37"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1689.49,830v36.34s-2.23.68-2.4,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1691.66,863.17s8.69-2.09,14.3-7.39c5.84-5.51,8.39-13.76-4.13-21.78a28.93,28.93,0,0,0-10.17-3.65v-.85a25.89,25.89,0,0,1,10.87,3.74c7.69,5,15.12,14.52,4.08,24.71a28,28,0,0,1-14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1714.31,825.69c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.88,1.94-11,12.87-11.21,25.74-11.21,13.06,0,24.08-.19,25.79,11.07C1714.47,814.7,1714.31,824.62,1714.31,825.69Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1657.21"
        cy="786.64"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1687.57,795.25v36.34s2.23.68,2.39,0-1.19-36.34-1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1685.4,828.44s-8.69-2.1-14.3-7.39c-5.85-5.52-8.39-13.76,4.13-21.78a28.93,28.93,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.88,3.73c-7.69,5-15.11,14.52-4.07,24.72a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1662.86,785.86c0,12.75,11.55,23.08,25.79,23.08s25.79-10.33,25.79-23.08c0-1.23.16-10.7,0-11.88-1.93-11-12.87-11.21-25.74-11.21-13.05,0-24.08-.19-25.79,11.07C1662.71,774.87,1662.86,784.79,1662.86,785.86Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1657.33"
        cy="746.81"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1689.6,755.41v36.35s-2.23.68-2.39,0,1.2-36.35,1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1691.78,788.61s8.68-2.1,14.3-7.39c5.84-5.52,8.38-13.76-4.13-21.78a28.8,28.8,0,0,0-10.17-3.66v-.84a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1714.43,751.12c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.22-.16-10.69.05-11.87,1.94-11,12.87-11.21,25.74-11.21,13,0,24.08-.2,25.79,11.07C1714.58,740.14,1714.43,750.06,1714.43,751.12Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1657.32"
        cy="712.07"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1687.69,720.68V757s2.23.68,2.39,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1685.51,753.87s-8.68-2.09-14.29-7.38c-5.85-5.52-8.39-13.76,4.12-21.79a29.08,29.08,0,0,1,10.17-3.65v-.85a26.05,26.05,0,0,0-10.87,3.74c-7.69,5-15.11,14.52-4.08,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1663.18,719.81c0,12,11.55,21.72,25.79,21.72s25.79-9.72,25.79-21.72c0-1.15.16-10.06,0-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13,0-24.08-.18-25.79,10.42C1663,709.48,1663.18,718.81,1663.18,719.81Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1657.65"
        cy="682.13"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1657.65"
        cy="680.64"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1715.7,686.6c0,12.75-11.54,23.09-25.78,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.69,0-11.87,1.93-11,12.87-11.22,25.74-11.22,13,0,24.07-.19,25.78,11.08C1715.86,675.61,1715.7,685.54,1715.7,686.6Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1658.6"
        cy="647.55"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1689,656.16v36.35s2.23.67,2.4,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1686.79,689.35s-8.69-2.09-14.3-7.39c-5.85-5.51-8.39-13.76,4.13-21.78a28.93,28.93,0,0,1,10.17-3.65v-.85a25.89,25.89,0,0,0-10.87,3.74c-7.69,5-15.12,14.52-4.08,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1663.18,651.67c0,12,11.55,21.72,25.79,21.72s25.79-9.72,25.79-21.72c0-1.15.16-10.06,0-11.17C1712.77,630.12,1701.84,630,1689,630c-13,0-24.08-.18-25.79,10.42C1663,641.34,1663.18,650.67,1663.18,651.67Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1657.65"
        cy="613.99"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1657.65"
        cy="612.5"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1714.43,611.92c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.69.05-11.87,1.94-11,12.87-11.22,25.74-11.22,13,0,24.08-.19,25.79,11.08C1714.58,600.94,1714.43,610.86,1714.43,611.92Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1657.32"
        cy="572.87"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1687.69,581.48v36.35s2.23.68,2.39,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1685.51,614.67s-8.68-2.09-14.29-7.39c-5.85-5.51-8.39-13.76,4.12-21.78a29.08,29.08,0,0,1,10.17-3.65V581a25.89,25.89,0,0,0-10.87,3.74c-7.69,5-15.11,14.52-4.08,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1715.7,556.16c0,12.76-11.54,23.09-25.78,23.09s-25.79-10.33-25.79-23.09c0-1.22-.16-10.69,0-11.87,1.93-11,12.87-11.21,25.74-11.21,13,0,24.07-.2,25.78,11.07C1715.86,545.18,1715.7,555.1,1715.7,556.16Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1658.6"
        cy="517.11"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1689,525.72v36.35s2.23.68,2.4,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1686.79,558.91s-8.69-2.09-14.3-7.38c-5.85-5.52-8.39-13.76,4.13-21.79a28.93,28.93,0,0,1,10.17-3.65v-.85a26.05,26.05,0,0,0-10.87,3.74c-7.69,5-15.12,14.52-4.08,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1287.15,1042.42c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.88,1.94-11,12.87-11.21,25.74-11.21,13.06,0,24.08-.19,25.79,11.07C1287.31,1031.43,1287.15,1041.35,1287.15,1042.42Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1230.05"
        cy="1003.37"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1260.41,1012v36.34s2.23.68,2.39,0-1.19-36.34-1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1258.24,1045.17s-8.69-2.1-14.3-7.39c-5.85-5.52-8.39-13.76,4.13-21.78a28.93,28.93,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.88,3.73c-7.69,5-15.11,14.52-4.07,24.72a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1234.63,1007.49c0,12,11.54,21.72,25.79,21.72s25.78-9.73,25.78-21.72c0-1.16.16-10.06,0-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.06,0-24.08-.18-25.79,10.42C1234.47,997.15,1234.63,1006.49,1234.63,1007.49Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1229.1"
        cy="969.81"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1229.1"
        cy="968.32"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1285.88,957.74c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.7,0-11.87,1.93-11,12.87-11.22,25.74-11.22,13.05,0,24.08-.19,25.79,11.08C1286,946.75,1285.88,956.67,1285.88,957.74Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1228.77"
        cy="918.69"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1259.14,927.3v36.34s2.23.68,2.39,0-1.2-36.34-1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1257,960.49s-8.68-2.09-14.3-7.39c-5.84-5.52-8.38-13.76,4.13-21.78a29,29,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.87,3.73c-7.69,5-15.11,14.53-4.08,24.72a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1320.27,1044.6c0,12,11.54,21.72,25.78,21.72s25.79-9.73,25.79-21.72c0-1.16.16-10.06,0-11.17-1.94-10.38-12.88-10.55-25.75-10.55-13,0-24.07-.18-25.78,10.42C1320.11,1034.26,1320.27,1043.6,1320.27,1044.6Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1314.74"
        cy="1006.92"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1314.74"
        cy="1005.43"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1371.51,1004.85c0,12.75-11.54,23.09-25.78,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.7,0-11.87,1.93-11,12.87-11.22,25.74-11.22,13,0,24.07-.19,25.78,11.07C1371.67,993.86,1371.51,1003.78,1371.51,1004.85Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1314.41"
        cy="965.8"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1344.77,974.41v36.34s2.23.68,2.4,0-1.2-36.34-1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1342.6,1007.6s-8.69-2.09-14.3-7.39c-5.84-5.52-8.39-13.76,4.13-21.78a28.93,28.93,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.87,3.73c-7.69,5-15.11,14.52-4.08,24.72a28,28,0,0,0,14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1287.15,898c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.7,0-11.87,1.94-11,12.87-11.22,25.74-11.22,13.06,0,24.08-.19,25.79,11.08C1287.31,887,1287.15,896.92,1287.15,898Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1230.05"
        cy="858.93"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1260.41,867.54v36.34s2.23.68,2.39,0-1.19-36.34-1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1258.24,900.73s-8.69-2.09-14.3-7.39c-5.85-5.51-8.39-13.76,4.13-21.78a28.93,28.93,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.88,3.74c-7.69,5-15.11,14.52-4.07,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1835.48,1043.35c0,12,11.55,21.72,25.79,21.72s25.79-9.73,25.79-21.72c0-1.16.16-10.07,0-11.17-1.94-10.39-12.87-10.55-25.74-10.55-13,0-24.08-.18-25.79,10.41C1835.33,1033,1835.48,1042.34,1835.48,1043.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1829.95"
        cy="1005.66"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1829.95"
        cy="1004.18"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1835.16,1021.51c0,12.75,11.55,23.09,25.79,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.88-1.93-11-12.87-11.21-25.74-11.21-13,0-24.08-.19-25.79,11.07C1835,1010.52,1835.16,1020.44,1835.16,1021.51Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1829.63"
        cy="982.46"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1861.9,991.07v36.34s-2.23.68-2.39,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1864.08,1024.26s8.68-2.1,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a29.08,29.08,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.72a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1886.73,986.78c0,12.75-11.55,23.08-25.79,23.08s-25.79-10.33-25.79-23.08c0-1.23-.16-10.7,0-11.88,1.94-11,12.87-11.21,25.74-11.21,13,0,24.08-.2,25.79,11.07C1886.88,975.79,1886.73,985.71,1886.73,986.78Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1829.62"
        cy="947.72"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1860,956.33v36.35s2.23.68,2.39,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1857.81,989.53s-8.68-2.1-14.29-7.39c-5.85-5.52-8.39-13.76,4.12-21.78a28.88,28.88,0,0,1,10.17-3.66v-.85a26.05,26.05,0,0,0-10.87,3.74c-7.69,5-15.11,14.52-4.08,24.71a28,28,0,0,0,15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1835.28,946.94c0,12.76,11.55,23.09,25.79,23.09s25.79-10.33,25.79-23.09c0-1.22.15-10.69,0-11.87-1.94-11-12.87-11.21-25.74-11.21-13.06,0-24.08-.2-25.79,11.07C1835.12,936,1835.28,945.88,1835.28,946.94Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1829.75"
        cy="907.89"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1862,916.5v36.35s-2.23.68-2.39,0,1.19-36.35,1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1864.19,949.69s8.69-2.09,14.3-7.38c5.85-5.52,8.39-13.76-4.12-21.79a29.06,29.06,0,0,0-10.18-3.65V916a26.07,26.07,0,0,1,10.88,3.74c7.69,5,15.11,14.52,4.07,24.71a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1886.84,912.21c0,12.75-11.54,23.09-25.78,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.7,0-11.87,1.93-11,12.87-11.22,25.74-11.22,13,0,24.08-.19,25.78,11.08C1887,901.22,1886.84,911.15,1886.84,912.21Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1829.74"
        cy="873.16"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1860.11,881.77v36.34s2.22.68,2.39,0-1.2-36.34-1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1857.93,915s-8.68-2.09-14.3-7.39c-5.84-5.51-8.39-13.76,4.13-21.78a29,29,0,0,1,10.17-3.65v-.85a25.89,25.89,0,0,0-10.87,3.74c-7.69,5-15.11,14.52-4.08,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1835.6,880.9c0,12,11.54,21.72,25.79,21.72s25.78-9.72,25.78-21.72c0-1.16.16-10.06,0-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.06,0-24.08-.18-25.79,10.42C1835.44,870.56,1835.6,879.9,1835.6,880.9Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1830.07"
        cy="843.22"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1830.07"
        cy="841.73"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1888.12,847.69c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.23-.15-10.7,0-11.87,1.94-11,12.87-11.22,25.74-11.22,13.06,0,24.08-.19,25.79,11.08C1888.28,836.7,1888.12,846.63,1888.12,847.69Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1831.02"
        cy="808.64"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1861.38,817.25v36.34s2.23.68,2.39,0-1.19-36.34-1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1859.21,850.44s-8.69-2.09-14.3-7.39c-5.85-5.51-8.39-13.76,4.12-21.78a29.06,29.06,0,0,1,10.18-3.65v-.85a25.91,25.91,0,0,0-10.88,3.74c-7.69,5-15.11,14.52-4.07,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1835.6,812.76c0,12,11.54,21.72,25.79,21.72s25.78-9.72,25.78-21.72c0-1.16.16-10.06,0-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.06,0-24.08-.18-25.79,10.42C1835.44,802.42,1835.6,811.76,1835.6,812.76Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1830.07"
        cy="775.08"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1830.07"
        cy="773.59"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1886.84,771c0,12.75-11.54,23.09-25.78,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.7,0-11.87,1.93-11,12.87-11.22,25.74-11.22,13,0,24.08-.19,25.78,11.08C1887,760,1886.84,770,1886.84,771Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1829.74"
        cy="731.96"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1860.11,740.57v36.34s2.22.68,2.39,0-1.2-36.34-1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1857.93,773.76s-8.68-2.09-14.3-7.39c-5.84-5.51-8.39-13.76,4.13-21.78a29,29,0,0,1,10.17-3.65v-.85a25.89,25.89,0,0,0-10.87,3.74c-7.69,5-15.11,14.52-4.08,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1888.12,731.25c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.23-.15-10.7,0-11.87,1.94-11,12.87-11.22,25.74-11.22,13.06,0,24.08-.19,25.79,11.08C1888.28,720.26,1888.12,730.19,1888.12,731.25Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1831.02"
        cy="692.2"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1861.38,700.81v36.34s2.23.68,2.39,0-1.19-36.34-1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1859.21,734s-8.69-2.09-14.3-7.39c-5.85-5.51-8.39-13.76,4.12-21.78a29.06,29.06,0,0,1,10.18-3.65v-.85a25.91,25.91,0,0,0-10.88,3.74c-7.69,5-15.11,14.52-4.07,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1575.15,1042.1c0,12.75,11.55,23.09,25.79,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.88-1.94-11-12.87-11.21-25.74-11.21-13,0-24.08-.19-25.79,11.07C1575,1031.11,1575.15,1041,1575.15,1042.1Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1569.62"
        cy="1003.05"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1601.89,1011.66V1048s-2.23.68-2.39,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1604.07,1044.85s8.68-2.1,14.29-7.39c5.85-5.52,8.39-13.76-4.12-21.78a28.88,28.88,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1626.72,997.36c0,12.76-11.55,23.09-25.79,23.09s-25.79-10.33-25.79-23.09c0-1.22-.16-10.69,0-11.87,1.93-11,12.87-11.21,25.74-11.21,13,0,24.08-.2,25.79,11.07C1626.87,986.38,1626.72,996.3,1626.72,997.36Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1569.61"
        cy="958.31"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1600,966.92v36.35s2.23.68,2.39,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1597.8,1000.11s-8.68-2.09-14.3-7.38c-5.84-5.52-8.38-13.76,4.13-21.78a28.8,28.8,0,0,1,10.17-3.66v-.85a26.05,26.05,0,0,0-10.87,3.74c-7.69,5-15.11,14.52-4.08,24.71a28,28,0,0,0,15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1575.47,946.05c0,12,11.55,21.72,25.79,21.72s25.78-9.72,25.78-21.72c0-1.15.16-10.06,0-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.06,0-24.08-.18-25.79,10.42C1575.31,935.72,1575.47,945.05,1575.47,946.05Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1569.94"
        cy="908.37"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1569.94"
        cy="906.88"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1628,892.84c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.69,0-11.87,1.94-11,12.87-11.22,25.74-11.22,13.06,0,24.08-.19,25.79,11.08C1628.15,881.86,1628,891.78,1628,892.84Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1570.89"
        cy="853.79"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1601.25,862.4v36.35s2.23.68,2.39,0-1.19-36.35-1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1599.08,895.59s-8.69-2.09-14.3-7.38c-5.85-5.52-8.39-13.77,4.13-21.79a28.93,28.93,0,0,1,10.17-3.65v-.85a26.05,26.05,0,0,0-10.87,3.74c-7.7,5-15.12,14.52-4.08,24.71a28,28,0,0,0,14.95,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1575.47,827.91c0,12,11.55,21.72,25.79,21.72s25.78-9.72,25.78-21.72c0-1.15.16-10.06,0-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.06,0-24.08-.18-25.79,10.42C1575.31,817.58,1575.47,826.91,1575.47,827.91Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1569.94"
        cy="790.23"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1569.94"
        cy="788.74"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1626.72,728.16c0,12.76-11.55,23.09-25.79,23.09s-25.79-10.33-25.79-23.09c0-1.22-.16-10.69,0-11.87,1.93-11,12.87-11.21,25.74-11.21,13,0,24.08-.2,25.79,11.07C1626.87,717.18,1626.72,727.1,1626.72,728.16Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1569.61"
        cy="689.11"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1600,697.72v36.35s2.23.68,2.39,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1597.8,730.91s-8.68-2.09-14.3-7.38c-5.84-5.52-8.38-13.76,4.13-21.79a29,29,0,0,1,10.17-3.65v-.85a26.05,26.05,0,0,0-10.87,3.74c-7.69,5-15.11,14.52-4.08,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1489.15,1044.71c0,12,11.55,21.72,25.79,21.72s25.79-9.72,25.79-21.72c0-1.15.15-10.06,0-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.06,0-24.08-.18-25.79,10.42C1489,1034.38,1489.15,1043.71,1489.15,1044.71Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1483.62"
        cy="1007.03"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1483.62"
        cy="1005.54"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1541.67,1001.5c0,12.75-11.54,23.09-25.79,23.09s-25.78-10.34-25.78-23.09c0-1.23-.16-10.69,0-11.87,1.94-11,12.87-11.22,25.74-11.22,13.06,0,24.08-.19,25.79,11.08C1541.83,990.51,1541.67,1000.44,1541.67,1001.5Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1484.57"
        cy="962.45"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1514.93,971.06v36.35s2.23.67,2.39,0-1.19-36.35-1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1512.76,1004.25s-8.69-2.09-14.3-7.39c-5.85-5.51-8.39-13.76,4.13-21.78a28.93,28.93,0,0,1,10.17-3.65v-.85a25.89,25.89,0,0,0-10.87,3.74c-7.7,5-15.12,14.52-4.08,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1489.15,936.57c0,12,11.55,21.72,25.79,21.72s25.79-9.72,25.79-21.72c0-1.15.15-10.06,0-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.06,0-24.08-.18-25.79,10.42C1489,926.24,1489.15,935.57,1489.15,936.57Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1483.62"
        cy="898.89"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1483.62"
        cy="897.4"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1540.4,836.82c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.69,0-11.87,1.93-11,12.87-11.22,25.74-11.22,13.05,0,24.08-.19,25.79,11.08C1540.55,825.84,1540.4,835.76,1540.4,836.82Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1483.29"
        cy="797.77"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1513.66,806.38v36.35s2.23.68,2.39,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1511.48,839.57s-8.68-2.09-14.29-7.38c-5.85-5.52-8.39-13.77,4.12-21.79a29.08,29.08,0,0,1,10.17-3.65v-.85a25.89,25.89,0,0,0-10.87,3.74c-7.69,5-15.11,14.52-4.08,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1628,608.41c0,12.75-11.54,23.08-25.79,23.08s-25.78-10.33-25.78-23.08c0-1.23-.16-10.7,0-11.88,1.94-11,12.87-11.21,25.74-11.21,13.06,0,24.08-.2,25.79,11.07C1628.15,597.42,1628,607.34,1628,608.41Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1570.89"
        cy="569.35"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1601.25,578v36.35s2.23.68,2.39,0-1.19-36.35-1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1599.08,611.16s-8.69-2.1-14.3-7.39c-5.85-5.52-8.39-13.76,4.13-21.78a28.73,28.73,0,0,1,10.17-3.66v-.85a26.05,26.05,0,0,0-10.87,3.74c-7.7,5-15.12,14.52-4.08,24.71a27.93,27.93,0,0,0,14.95,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1837.77,698.13c0,12.75,11.55,23.09,25.79,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.87-1.93-11-12.87-11.22-25.74-11.22-13,0-24.08-.19-25.79,11.08C1837.62,687.14,1837.77,697.07,1837.77,698.13Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1832.25"
        cy="659.08"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1864.51,667.69V704s-2.22.68-2.39,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1866.69,700.88s8.68-2.09,14.3-7.39c5.84-5.51,8.38-13.76-4.13-21.78a29,29,0,0,0-10.17-3.65v-.85a25.89,25.89,0,0,1,10.87,3.74c7.69,4.95,15.11,14.52,4.08,24.71a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1838.09,666.49c0,12,11.55,21.72,25.79,21.72s25.79-9.72,25.79-21.72c0-1.15.16-10.06-.05-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.05,0-24.08-.18-25.79,10.42C1837.94,656.15,1838.09,665.49,1838.09,666.49Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1832.56"
        cy="628.81"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1832.56"
        cy="627.32"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1838.09,629.56c0,12,11.55,21.72,25.79,21.72s25.79-9.73,25.79-21.72c0-1.16.16-10.06-.05-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.05,0-24.08-.18-25.79,10.42C1837.94,619.22,1838.09,628.56,1838.09,629.56Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1832.56"
        cy="591.88"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1832.56"
        cy="590.39"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1837.77,595.72c0,12.75,11.55,23.09,25.79,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.87-1.93-11-12.87-11.22-25.74-11.22-13,0-24.08-.19-25.79,11.08C1837.62,584.73,1837.77,594.66,1837.77,595.72Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1832.25"
        cy="556.67"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1864.51,565.28v36.34s-2.22.68-2.39,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1866.69,598.47s8.68-2.09,14.3-7.39c5.84-5.51,8.38-13.76-4.13-21.78a29,29,0,0,0-10.17-3.65v-.85a25.89,25.89,0,0,1,10.87,3.74c7.69,5,15.11,14.52,4.08,24.71a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1889.34,561c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.7,0-11.87,1.94-11,12.87-11.22,25.74-11.22,13,0,24.08-.19,25.79,11.08C1889.49,550,1889.34,559.92,1889.34,561Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1832.23"
        cy="521.94"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1862.6,530.55v36.34s2.23.68,2.39,0-1.19-36.34-1.19-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1860.42,563.74s-8.68-2.09-14.29-7.39c-5.85-5.52-8.39-13.76,4.12-21.78a29.08,29.08,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.87,3.73c-7.69,5-15.11,14.52-4.07,24.72a28,28,0,0,0,14.94,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1838.09,529.68c0,12,11.55,21.72,25.79,21.72s25.79-9.73,25.79-21.72c0-1.16.16-10.07-.05-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.05,0-24.08-.18-25.79,10.42C1837.94,519.34,1838.09,528.68,1838.09,529.68Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1832.56"
        cy="492"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1832.56"
        cy="490.51"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1890.61,496.47c0,12.75-11.54,23.09-25.78,23.09S1839,509.22,1839,496.47c0-1.23-.16-10.7,0-11.88,1.93-11,12.87-11.21,25.74-11.21,13.05,0,24.07-.19,25.78,11.07C1890.77,485.48,1890.61,495.4,1890.61,496.47Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1833.51"
        cy="457.42"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1863.87,466v36.35s2.23.68,2.4,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1861.7,499.22s-8.69-2.1-14.3-7.39c-5.84-5.52-8.39-13.76,4.13-21.78a28.61,28.61,0,0,1,10.17-3.65v-.85a26,26,0,0,0-10.87,3.73c-7.69,5-15.11,14.52-4.08,24.71a27.93,27.93,0,0,0,15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1838.09,461.54c0,12,11.55,21.72,25.79,21.72s25.79-9.73,25.79-21.72c0-1.16.16-10.07-.05-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.05,0-24.08-.18-25.79,10.42C1837.94,451.2,1838.09,460.54,1838.09,461.54Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1832.56"
        cy="423.86"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1832.56"
        cy="422.37"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1838.09,419.22c0,12,11.55,21.72,25.79,21.72s25.79-9.73,25.79-21.72c0-1.16.16-10.07-.05-11.17-1.94-10.39-12.87-10.55-25.74-10.55-13.05,0-24.08-.18-25.79,10.41C1837.94,408.88,1838.09,418.22,1838.09,419.22Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1832.56"
        cy="381.53"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1832.56"
        cy="380.05"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1838.09,372.28c0,12,11.55,21.72,25.79,21.72s25.79-9.72,25.79-21.72c0-1.15.16-10.06-.05-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.05,0-24.08-.18-25.79,10.42C1837.94,362,1838.09,371.28,1838.09,372.28Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1832.56"
        cy="334.6"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1832.56"
        cy="333.11"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1836.82,316c0,12.75,11.54,23.09,25.78,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.87-1.94-11-12.88-11.22-25.75-11.22-13,0-24.07-.19-25.78,11.08C1836.66,305,1836.82,314.91,1836.82,316Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1831.29"
        cy="276.93"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1863.56,285.54v36.34s-2.23.68-2.4,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1865.73,318.73s8.69-2.09,14.3-7.39c5.85-5.52,8.39-13.76-4.13-21.78a28.93,28.93,0,0,0-10.17-3.65v-.85a26,26,0,0,1,10.87,3.73c7.7,5,15.12,14.53,4.08,24.72a28,28,0,0,1-15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1889.34,243.71c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.22-.16-10.69,0-11.87,1.94-11,12.87-11.21,25.74-11.21,13,0,24.08-.2,25.79,11.07C1889.49,232.73,1889.34,242.65,1889.34,243.71Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1832.23"
        cy="204.66"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1862.6,213.27v36.35s2.23.68,2.39,0-1.19-36.35-1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1860.42,246.46s-8.68-2.09-14.29-7.38c-5.85-5.52-8.39-13.76,4.12-21.79a29.08,29.08,0,0,1,10.17-3.65v-.85a26.05,26.05,0,0,0-10.87,3.74c-7.69,5-15.11,14.52-4.07,24.71a28,28,0,0,0,14.94,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1838.09,152.4c0,12,11.55,21.72,25.79,21.72s25.79-9.72,25.79-21.72c0-1.15.16-10.06-.05-11.17-1.94-10.38-12.87-10.55-25.74-10.55-13.05,0-24.08-.18-25.79,10.42C1837.94,142.07,1838.09,151.4,1838.09,152.4Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1832.56"
        cy="114.72"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1832.56"
        cy="113.23"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1890.61,59.19c0,12.75-11.54,23.09-25.78,23.09S1839,71.94,1839,59.19c0-1.23-.16-10.69,0-11.87,1.93-11,12.87-11.22,25.74-11.22,13.05,0,24.07-.19,25.78,11.08C1890.77,48.2,1890.61,58.13,1890.61,59.19Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1833.51"
        cy="20.14"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1863.87,28.75V65.1s2.23.67,2.4,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1861.7,61.94s-8.69-2.09-14.3-7.39c-5.84-5.51-8.39-13.76,4.13-21.78a29,29,0,0,1,10.17-3.65v-.85A25.89,25.89,0,0,0,1850.83,32c-7.69,5-15.11,14.52-4.08,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1664.52,500c0,12.75,11.54,23.09,25.78,23.09s25.79-10.34,25.79-23.09c0-1.23.16-10.7,0-11.88-1.93-11-12.87-11.21-25.74-11.21-13,0-24.07-.19-25.78,11.07C1664.36,489,1664.52,498.88,1664.52,500Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1658.99"
        cy="460.9"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1691.26,469.51v36.34s-2.23.68-2.4,0,1.2-36.34,1.2-36.34Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1693.43,502.7s8.69-2.1,14.3-7.39c5.84-5.52,8.39-13.76-4.13-21.78a28.73,28.73,0,0,0-10.17-3.65V469a26,26,0,0,1,10.87,3.73c7.69,5,15.12,14.52,4.08,24.71a27.93,27.93,0,0,1-15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1717.08,418.21c0,12.76-11.54,23.09-25.79,23.09s-25.78-10.33-25.78-23.09c0-1.22-.16-10.69,0-11.87,1.94-11,12.87-11.21,25.74-11.21,13.06,0,24.08-.2,25.79,11.07C1717.24,407.23,1717.08,417.15,1717.08,418.21Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1659.98"
        cy="379.16"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1690.34,387.77v36.35s2.23.68,2.39,0-1.19-36.35-1.19-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1688.17,421s-8.69-2.09-14.3-7.38c-5.85-5.52-8.39-13.76,4.13-21.78a28.73,28.73,0,0,1,10.17-3.66v-.85a26.12,26.12,0,0,0-10.88,3.74c-7.69,5-15.11,14.52-4.07,24.71a27.93,27.93,0,0,0,15,7.65Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1665.83,326.9c0,12,11.55,21.72,25.79,21.72s25.79-9.72,25.79-21.72c0-1.15.16-10.06-.05-11.17-1.93-10.38-12.87-10.55-25.74-10.55-13,0-24.08-.18-25.79,10.42C1665.68,316.57,1665.83,325.9,1665.83,326.9Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1660.31"
        cy="289.22"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1660.31"
        cy="287.73"
        rx="23.88"
        ry="18.65"
      />
    </g>
    <g class="pill">
      <path
        class="cls-1-stack white"
        d="M1718.36,223.69c0,12.75-11.55,23.09-25.79,23.09s-25.79-10.34-25.79-23.09c0-1.23-.16-10.69,0-11.87,1.93-11,12.87-11.22,25.74-11.22,13,0,24.08-.19,25.79,11.08C1718.51,212.71,1718.36,222.63,1718.36,223.69Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-2-stack white"
        cx="1661.25"
        cy="184.64"
        rx="25.79"
        ry="20.14"
      />
      <path
        class="cls-1-stack white"
        d="M1691.62,193.25V229.6s2.23.68,2.39,0-1.2-36.35-1.2-36.35Z"
        transform="translate(-31.32 -26.93)"
      />
      <path
        class="cls-1-stack white"
        d="M1689.44,226.44s-8.68-2.09-14.3-7.38c-5.84-5.52-8.38-13.77,4.13-21.79a29,29,0,0,1,10.17-3.65v-.85a25.89,25.89,0,0,0-10.87,3.74c-7.69,5-15.11,14.52-4.08,24.71a28,28,0,0,0,15,7.64Z"
        transform="translate(-31.32 -26.93)"
      />
    </g>
    <g class="pill">
      <path
        class="cls-3-stack blue"
        d="M1665.83,108.76c0,12,11.55,21.72,25.79,21.72s25.79-9.72,25.79-21.72c0-1.15.16-10.06-.05-11.17C1715.43,87.21,1704.49,87,1691.62,87c-13,0-24.08-.18-25.79,10.42C1665.68,98.43,1665.83,107.76,1665.83,108.76Z"
        transform="translate(-31.32 -26.93)"
      />
      <ellipse
        class="cls-4-stack blue"
        cx="1660.31"
        cy="71.08"
        rx="25.79"
        ry="20.14"
      />
      <ellipse
        class="cls-5-stack blue"
        cx="1660.31"
        cy="69.59"
        rx="23.88"
        ry="18.65"
      />
    </g>
  </svg>
</template>
<style>
#stacked-pills {
  /* background-position: center;
  background-size: cover; */
  width: 100%;
  height: 100%;
  z-index: 99999999999999999999999;
}
.cls-1-stack {
  fill: rgb(168, 181, 185);
  stroke: none;
}
.cls-2-stack {
  fill: #efeff0;
  stroke: none;
}
.cls-3-stack {
  fill: #8ca3a1;
  stroke: none;
}
.cls-4-stack {
  fill: #a5c7c5;
  stroke: none;
}
.cls-5-stack {
  fill: #d6e9e9;
  stroke: none;
}
</style>
